//File to include additional color presets, if needed.

export const brandColor = {
    color: "brand.600",
    _dark: { color: "brand.500" },
};
